module.exports = __webpack_public_path__ + "img/carport.104719a0.jpg";